module.exports = __webpack_public_path__ + "media/door-open.97e74b5f.mp3";